import script from "./EmployeeViewAllSOPFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeViewAllSOPFiles.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeViewAllSOPFiles.vue?vue&type=style&index=0&id=563f9153&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563f9153"]])

export default __exports__